import { Component, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as _ from "lodash-es";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SubSink } from "subsink";
import { IRosterCode } from "../shared/models/roster-code";
import { IEntity } from "../shared/models/entity";
import { IRosterProject } from "../shared/models/roster/roster-project";
import { Role } from "../shared/models/role";
import { AuthenticationService } from "../services/authentication.service";
import { BusinessOperation } from "../shared/models/business-operation";

@Component({
  selector: "pps-roster-project-form",
  templateUrl: "./roster-project-form.component.html",
  styles:[`
    .roster-project-form .item {
      display: flex;
      align-items: center;
      padding: 0rem 0.5rem;
      width: 100%;
    }
    .roster-project-form .p-picklist .p-picklist-list .p-picklist-item{
      padding: 0rem;
    }
    /*
    This class is important to make sure the drag preview item is not displayed beneath the dynamic dialog. 
    Another way is to set autoZIndex = false when open the component in addOrUpdateRosterSummaryLine() method
    */
    .p-picklist-item.cdk-drag-preview{
      z-index:2000 !important;
      padding: 0rem 0.75rem;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class RosterProjectFormComponent{
  private subs = new SubSink();

  errorMessage = "";
  workGroups: IEntity[] = [];
  roles: Role[] = [];
  rosterCodes: IRosterCode[] = [];
  
  selectedWorkGroups: IEntity[] = [];
  rosterProject: IRosterProject = {};
  
  constructor(
    private _authService: AuthenticationService,
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig) {
    this.setData(this._dlgConfig.data);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setData(data: any){
    this.workGroups = _.cloneDeep(data.workGroups);
    this.rosterProject = _.cloneDeep(data.rosterProject);
    this.roles = data.roles;
    this.rosterProject.groupIds.forEach(id => {
      let index = this.workGroups.findIndex(rg => rg.id === id);
      if (index !== -1){
        this.selectedWorkGroups.push(this.workGroups[index]);
        this.workGroups.splice(index, 1);
      }
    });
  }

  save(form: NgForm){
    this.errorMessage = "";

    if (form.invalid){
      return false;
    }

    if (!this.rosterProject.title){
      this.errorMessage = "Please provide a title for the summary"
      return;
    }

    this.rosterProject.groupIds = [];
    this.selectedWorkGroups.forEach(rg => this.rosterProject.groupIds.push(rg.id));
    this._dialogRef.close(this.rosterProject);
  }

  cancel(){
    this._dialogRef.close();
  }

  /**
   * Check if current user has permission to config roster project permission.
   * @returns true with permission, false without.
   */
   canSetPermission(): boolean{
    return this._authService.canUserDoOperartion(BusinessOperation.ManageRosterProjectPermission);
  }
}